import { Injectable } from '@angular/core';

/**
 * Handles modal interactions.
 */
@Injectable({
  providedIn: 'root'
})
export class CustomerOverViewService {
  public listOfModals: any = {
    editCustomerModalOpened: false,
    editCommunicationModalOpened: false,
    editAttributeModalOpened: false,
    createAddressesModalOpened: false,
    editAddressesModalOpened: false,
    createBankingDataModalOpened: false,
    editBankingDataModalOpened: false,
    createCrmMembershipModalOpened: false,
    editCrmMembershipModalOpened: false,
    editCampaiMembershipModalOpened: false,
    createContactModalOpened: false,
    editContactModalOpened: false,
    selectBankAccountModalOpened: false,
    viewInvoicesModalOpened: false,
    createReminderModalOpened: false,
    updateReminderModalOpened: false,
    viewSubmissionDetailsModalOpened: false,
  };

  public deleteModal: any = {
    deleteModalOpened: false,
    deleteModalType: '',
    deleteModalId: null,
  };

  public loadingSubmitClicked: boolean = false;
  public bankAccountSelectModalOpened: any = true;

  constructor() { }

  /**
   * Set the status to all modals.
   */
  public toggleAllModal(status: boolean): any {
    this.toggleEditCustomerModal(status);
    this.toggleEditCommunicationModal(status);
    this.toggleCreateAddressesModal(status);
    this.toggleCreateBankingDataModal(status);
    this.toggleCreateCrmMembershipModal(status);
    this.toggleEditCrmMembershipModal(status);
    this.toggleEditCampaiMembershipModal(status);
    this.toggleEditBankingDataModal(status);
    this.toggleEditAddressesModal(status);
    this.toggleEditAttributeDataModal(status);
    this.toggleNewContactModal(status);
    this.toggleEditContactModal(status);
    this.toggleSelectBankAccountModal(status);
    this.toggleInvoicesModal(status);
    this.toggleEditReminderModal(status);
    this.toggleCreateReminderModal(status);
    this.toggleViewSubmissionDetailsModal(status);
  }

  /**
   * Set the status of the edit customer modal.
   */
  public toggleEditCustomerModal(status: boolean): void {
    this.listOfModals.editCustomerModalOpened = status;
  }

  /**
   * Set the status of the edit communication modal.
   */
  public toggleEditCommunicationModal(status: boolean): void {
    this.listOfModals.editCommunicationModalOpened = status;
  }
  /**
   * Set the status of the edit addresses modal.
   */
  public toggleEditAddressesModal(status: boolean): void {
    this.listOfModals.editAddressesModalOpened = status;
  }

  /**
   * Set the status of the create addresses modal.
   */
  public toggleCreateAddressesModal(status: boolean): void {
    this.listOfModals.createAddressesModalOpened = status;
  }

  public toggleCreateBankingDataModal(status: boolean): void {
    this.listOfModals.createBankingDataModalOpened = status;
  }

  public toggleEditBankingDataModal(status: boolean): void {
    this.listOfModals.editBankingDataModalOpened = status;
  }

  public toggleCreateCrmMembershipModal(status: boolean): void {
    this.listOfModals.createCrmMembershipModalOpened = status;
  }

  public toggleEditCrmMembershipModal(status: boolean): void {
    this.listOfModals.editCrmMembershipModalOpened = status;
  }

  public toggleEditCampaiMembershipModal(status: boolean): void {
    this.listOfModals.editCampaiMembershipModalOpened = status;
  }

  public toggleViewSubmissionDetailsModal(status: boolean): void {
    this.listOfModals.viewSubmissionDetailsModalOpened = status;
  }

  /**
   * Set the status of the edit attributes modal.
   */
  public toggleEditAttributeDataModal(status: boolean): void {
    this.listOfModals.editAttributeModalOpened = status;
  }

  /**
   * Set the status of the edit customer modal.
   */
  public toggleNewContactModal(status: boolean): void {
    this.listOfModals.createContactModalOpened = status;
  }

  /**
   * Set the status of the edit customer modal.
   */
  public toggleEditContactModal(status: boolean): void {
    this.listOfModals.editContactModalOpened = status;
  }

  /**
   * Set the status for invoices modal
   */
  public toggleInvoicesModal(status: boolean): void {
    this.listOfModals.viewInvoicesModalOpened = status;
  }

  /**
   * Set the status for create reminder modal
   */
  public toggleCreateReminderModal(status: boolean): void {
    this.listOfModals.createReminderModalOpened = status;
  }

  /**
   * Set the status for edit reminder modal
   */
  public toggleEditReminderModal(status: boolean): void {
    this.listOfModals.updateReminderModalOpened = status;
  }

  /**
   * Set the status of the delete modal.
   */
  public toggleDeleteModal(status: boolean, type?: string, id?: number): void {
    this.deleteModal.deleteModalOpened = status;
    this.deleteModal.deleteModalType = type;
    this.deleteModal.deleteModalId = id;
  }

  /**
   * Sets the current loading process to true of false
   */
  public toggleLoadingSubmitClicked(status: boolean): void {
    this.loadingSubmitClicked = status;
  }

  /**
   * Set the status of the select bank account modal.
   */
  public toggleSelectBankAccountModal(status: boolean): void {
    this.listOfModals.selectBankAccountModalOpened = status;
    this.bankAccountSelectModalOpened = status;
  }

}
